import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeoutId: number;
    const showNext = () => {
      setVisible(true);
      timeoutId = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % purchaseNotifications.length);
        timeoutId = window.setTimeout(showNext, 9000);
      }, 5500);
    };
    timeoutId = window.setTimeout(showNext, 6000);
    return () => window.clearTimeout(timeoutId);
  }, [dismissed, index]);
  if (dismissed) return null;
  const item = purchaseNotifications[index];
  const minutesAgo = index * 3 % 11 + 2;
  return <AnimatePresence data-id="element-39" data-mp="1gwujam4190nh">
      {visible ? <motion.aside initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} aria-live="polite" className="fixed bottom-24 left-3 right-3 z-40 mx-auto max-w-[340px] rounded-2xl border border-navy-100 bg-white p-3 shadow-[0_16px_40px_-16px_rgba(8,32,60,0.45)] sm:left-5 sm:right-auto sm:mx-0 sm:bottom-28" data-id="element-40" data-mp="1657kx3w7ttz8">
          <div className="flex items-start gap-3" data-id="element-41" data-mp="i93fyd1jgdu6">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy-900 text-lg" aria-hidden="true" data-id="element-42" data-mp="iaegm3zot5h2">
              {item.flag}
            </span>
            <div className="min-w-0 flex-1" data-id="element-43" data-mp="s8av95ru2ijx">
              <p className="text-[13px] font-bold leading-snug text-navy-900" data-id="element-44" data-mp="28joki88hrckq">
                {item.name} <span className="font-medium text-navy-500" data-id="element-45" data-mp="23lwigle4ua2t">from {item.country}</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[12px] font-medium leading-snug text-navy-500" data-id="element-46" data-mp="2ap32tfour0dt">
                <CheckCircle2Icon className="h-3.5 w-3.5 shrink-0 text-emerald-600" aria-hidden="true" data-id="element-47" data-mp="2fmmp92vpejgu" />
                Purchased Kidney Disease Route™
              </p>
              <p className="mt-0.5 text-[11px] font-medium text-navy-400" data-id="element-48" data-mp="2plk8bqad1ksg">{minutesAgo} minutes ago</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="-mr-1 -mt-1 rounded-lg p-1.5 text-navy-300 transition-colors duration-150 ease-out hover:bg-navy-50 hover:text-navy-600" data-id="element-49" data-mp="1ryv2f5cjeo1b">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-50" data-mp="26o19tglj3kka" />
            </button>
          </div>
        </motion.aside> : null}
    </AnimatePresence>;
}